













































































import {Mixins, Component, Watch} from 'vue-property-decorator';
import Common from '@/components/term/mixins/Common';
import PageTitle from '@/components/common/PageTitle.vue';
import MallTabPlus from '@/components/common/MallTabPlus.vue';
import ContentBottom from '@/components/term/common/ContentBottom.vue';
import editor from '@/components/common/summernote/Index.vue';

@Component({
  components: {
    PageTitle,
    MallTabPlus,
    ContentBottom,
    editor
  }
})
export default class Introduction extends Mixins(Common) {
  @Watch('currentMallNo')
  private mallNoChange() {
    this.afterGetTerms();
  }
}
